import React from "react";

type CsvCell = string | number | boolean | null | undefined;

interface CsvDownloadLinkProps {
  data: CsvCell[][];
  filename: string;
  children?: React.ReactNode;
}

const toCsvString = (data: CsvCell[][]) =>
  data
    .map((row) =>
      row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");

const CsvDownloadLink = ({
  data,
  filename,
  children,
}: CsvDownloadLinkProps) => {
  const href = `data:text/csv;charset=utf-8,${encodeURIComponent(
    toCsvString(data)
  )}`;
  return (
    <a href={href} download={filename}>
      {children}
    </a>
  );
};

export default CsvDownloadLink;
